import type {} from "@lit/react";
import { Card as CardElement, } from "@vaadin/card/vaadin-card.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { CardElement, };
export type CardEventMap = Readonly<{}>;
const events = {} as CardEventMap;
export type CardProps = WebComponentProps<CardElement, CardEventMap>;
export const Card = createComponent({
    elementClass: CardElement, events, react: React, tagName: "vaadin-card"
});
